import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=916a2486&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916a2486",
  null
  
)

export default component.exports